module.exports = __webpack_public_path__ + "static/media/macOrchard.32e2f209.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/macOrchard.jpg
// module id = 767
// module chunks = 0